/* eslint-disable react/prop-types */
import React, { useEffect, useState, useMemo } from 'react';

import CreateButton from '../../../elements/CreateButton';
import DeleteButton from '../../../elements/DeleteButton';
import EditButton from '../../../elements/EditButton';
import Loader from '../../../elements/Loader';
import Table from '../../../elements/Table';
import ViewButton from '../../../elements/ViewButton';
import Paginator from '../../../elements/paginator';
import axios from '../../../services/MyAxios';
import { CRM_PERMISSION } from '../Helpers/CrmPermissions';
import {
    CASINO_TOURNAMENTS_CREATE,
    CASINO_TOURNAMENTS_EDIT,
    CASINO_TOURNAMENTS_EDIT_GAMES,
    CASINO_TOURNAMENTS_SHOW,
} from '../Helpers/CrmUrls';
import { replaceUrlParams } from '../Helpers/UrlHelper';

function TournamentsList() {
    const [tournament, setTournament] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);

    const apiUrl = '/crea/casino/api/tournaments';

    function getTournaments(page) {
        setIsLoading(true);
        axios
            .get(apiUrl, {
                params: {
                    page,
                },
            })
            .then((response) => {
                setTournament(response.data.data);
                setCurrentPage(response.data.current_page);
                setLastPage(response.data.last_page);
            });
        setIsLoading(false);
    }

    useEffect(() => {
        getTournaments(currentPage);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Slug',
                accessor: 'url',
                Cell: ({ value }) => (
                    <a href={value} target="_blank" rel="noreferrer">
                        {value}
                    </a>
                ),
            },
            {
                Header: 'Language code',
                accessor: 'language.code',
            },
            {
                Header: 'Image',
                accessor: 'image_path',
                Cell: ({ value }) => <img style={{ maxWidth: '25%' }} src={`${value}`} alt="" />,
            },
            {
                Header: 'Actions',
                accessor: 'id',
                Cell: ({ value }) => (
                    <div>
                        <ViewButton
                            url={replaceUrlParams(CASINO_TOURNAMENTS_SHOW, { id: value })}
                            permissions={[CRM_PERMISSION.TOURNAMENT_SHOW]}
                            key="view"
                        />
                        <EditButton
                            url={replaceUrlParams(CASINO_TOURNAMENTS_EDIT, { id: value })}
                            permissions={[CRM_PERMISSION.TOURNAMENT_EDIT]}
                            key="edit"
                        />
                        <EditButton
                            url={replaceUrlParams(CASINO_TOURNAMENTS_EDIT_GAMES, { id: value })}
                            permissions={[CRM_PERMISSION.TOURNAMENT_EDIT]}
                            key="edit_games"
                        />
                        <DeleteButton
                            url={`/crea/casino/api/tournaments/${value}`}
                            action={() => getTournaments(currentPage)}
                            permissions={[CRM_PERMISSION.TOURNAMENT_DELETE]}
                            key="delete"
                        />
                    </div>
                ),
            },
        ],
        []
    );

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <span>All tournaments</span>
                <CreateButton
                    url={CASINO_TOURNAMENTS_CREATE}
                    permissions={[CRM_PERMISSION.TOURNAMENT_CREATE]}
                    key="create"
                    buttonText="Create a new tournament"
                />
            </div>
            <div className="card-body">
                <Loader loading={isLoading} content={() => <Table columns={columns} data={tournament} />} />
                <Paginator
                    currentPage={currentPage}
                    lastPage={lastPage}
                    onPageChange={(page) => getTournaments(page)}
                />
            </div>
        </div>
    );
}

export default TournamentsList;
